export default "skymp5-front/db8a9ca649e5fdd4f5fb4b7327f5f03a.gif";